import { atomWithDefault } from "jotai/utils";
import { useAtomValue, useSetAtom } from "jotai";
import { getTopicTypeList } from "../../question";
import { atom } from "jotai";
import { toNumber } from "../../service";

export const typesAtom = atomWithDefault(async () => {
    return await getTopicTypeList();
});

// 所有可用试题类型id
export const typeIdsAtom = atom(get =>
    get(typesAtom).map(item => toNumber(item.id))
);

// 获取所有试题类型列表
export function useTopicTypes() {
    return useAtomValue(typesAtom);
}

// 从服务器更新试题类型
export function useUpdateTypes() {
    const updateTypes = useSetAtom(typesAtom);

    async function update() {
        const types = await getTopicTypeList();
        updateTypes(types);
    }

    return update;
}
